import React from 'react';

import { PropTypes } from 'prop-types';

import Address from './Address';
import AdditionalData from './AdditionalData';
import GeneralMoralData from './GeneralMoralData';
import RepresentativePersonData from './RepresentativePersonData';

const MoralPerson = ({ isInsuredPerson }) => {
  return (
    <div className="form-fields">
      <GeneralMoralData />
      <RepresentativePersonData />
      <Address isInsuredPerson={isInsuredPerson} />
      <AdditionalData isInsuredPerson={isInsuredPerson} />
    </div>
  );
};

MoralPerson.propTypes = {
  isInsuredPerson: PropTypes.bool.isRequired,
};

export default MoralPerson;
